/**
 * <aura-video-trigger> — click-to-play facade for testimonial/product videos.
 * Keeps YouTube/Vimeo iframes and <video> elements out of the initial DOM
 * until the shopper actually wants to watch, so the poster image is all
 * that loads on page render.
 */
class AuraVideoTrigger extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('[data-aura-play]');
    if (!button) return;
    button.addEventListener('click', () => this.play(), { once: true });
  }

  play() {
    const template = this.querySelector('template');
    if (!template) return;
    const fragment = template.content.cloneNode(true);
    this.innerHTML = '';
    this.appendChild(fragment);

    const media = this.querySelector('video');
    if (media) media.play().catch(() => {});
  }
}

if (!customElements.get('aura-video-trigger')) {
  customElements.define('aura-video-trigger', AuraVideoTrigger);
}
